module.exports = __webpack_public_path__ + "img/veloshop.ca_champ-rues.914004c2.jpg";